<!-- Shared Profile Menu Content Template -->
<ng-template #profileMenuContent>
  <!-- Profile Header -->
  <div class="flex items-center gap-3 mb-4">
    @if (profileService.profileDetails()?.profileImagePath) {
      <img [src]="profileService.profileDetails()?.profileImagePath" 
           alt="User Avatar"
           class="w-9 h-9 rounded-full object-cover border border-grey-200" />
    } @else {
      <div class="w-9 h-9 rounded-full border border-grey-200 bg-black flex items-center justify-center">
        <span class="text-white text-sm font-semibold">
          {{ fullName() | initials }}
        </span>
      </div>
    }
    <div class="flex-1 text-lg font-medium text-grey-900">
      {{ profileService.profileDetails()?.firstName }} {{ profileService.profileDetails()?.lastName }}
    </div>
  </div>

  <!-- Actions -->
  <div class="flex flex-col gap-2">
    <p-button
      severity="secondary"
      [text]="true"
      styleClass="flex items-center gap-2 px-2 py-2 rounded-xl text-sm text-neutral-950 hover:bg-grey-50 transition-colors cursor-pointer !border-0 !shadow-none !w-full !justify-start"
      (click)="onProfileClick($event)">
      <i class="pi pi-user text-neutral-950 text-base"></i>
      <span class="text-neutral-950">My Profile</span>
    </p-button>

    <p-button
      severity="secondary"
      [text]="true"
      [disabled]="isLoggingOut()"
      styleClass="flex items-center gap-2 px-2 py-2 rounded-xl text-sm text-neutral-950 hover:bg-grey-50 transition-colors cursor-pointer !border-0 !shadow-none !w-full !justify-start"
      (click)="onSwitchWorkspaceClick($event)">
      <i class="pi pi-arrow-right-arrow-left text-neutral-950 text-base"></i>
      <span class="text-neutral-950">Switch Workspace</span>
    </p-button>

    <p-button
      severity="secondary"
      [text]="true"
      [loading]="isLoggingOut()"
      [disabled]="isLoggingOut()"
      styleClass="flex items-center gap-2 px-2 py-2 rounded-xl text-sm text-neutral-950 hover:bg-grey-50 transition-colors cursor-pointer !border-0 !shadow-none !w-full !justify-start"
      (click)="onLogoutClick($event)">
      @if (!isLoggingOut()) {
        <i class="pi pi-sign-out text-neutral-950 text-base"></i>
      }
      <span class="text-neutral-950">{{ isLoggingOut() ? 'Logging out...' : 'Logout' }}</span>
    </p-button>
  </div>
</ng-template>

<!-- Desktop: Popover -->
<p-popover #profileMenuOverlay [dismissable]="true" [appendTo]="'body'"
  [style]="{ 'min-width': '270px' }">
  <ng-template #content>
    <div class="p-5">
      <ng-container *ngTemplateOutlet="profileMenuContent" />
    </div>
  </ng-template>
</p-popover>

<!-- Mobile: Drawer -->
<app-foxera-drawer-bottom 
  [(visible)]="mobileDrawerVisible" 
  [title]="'Profile'">
  <div class="px-4 pb-4">
    <ng-container *ngTemplateOutlet="profileMenuContent" />
  </div>
</app-foxera-drawer-bottom>

<!-- Profile Dialog -->
<app-profile-dialog 
  [isVisible]="showProfileDialog()" 
  [profileData]="profileData"
  (visibilityChange)="onProfileDialogVisibilityChange($event)" />